import React from 'react';
import { observer } from 'mobx-react';
import { reaction } from 'mobx';

import { constants } from '../../config';
import { ScreenStore } from '../../stores/ScreenStore';
import { CartStore } from '../../stores/CartStore';
import { Footer } from '../../common/footer';
import { HomeNavbar } from '../../common/home-navbar';
import { ProductTable } from './product-table';
import { Summary } from './summary';
import styles from './Cart.css';
import { Spinner } from '../../common/spinner';
import * as modalGlobal from '../../common/global/modal';
import { InfoModal } from '../../common/info-modal';
import { AlertZone } from '../../common/alert-zone';
import { SEO } from '../../common/seo';
import { GA4 } from '../../helpers/GA4';


const Cart = observer(class Cart extends React.Component {
  componentDidMount() {
    this._handleMessage = this._handleMessage.bind(this);
    this.disposer = reaction(
      () => CartStore.isFetchingCart,
      () => {
        if (CartStore.cart) {
          GA4.beginCheckoutEvent(
            CartStore.cartTotalPriceString,
            CartStore.cart.map(x => ({
              item_id: x.product.id,
              item_name: x.product.name.trim(),
              quantity: x.amount,
              price: x.product.financing.price,
            })),
          );
        }
      },
    );
  }

  componentWillUnmount() {
    CartStore.flushLastDeletions();
  }

  // eslint-disable-next-line class-methods-use-this
  _handleMessage() {
    const message = `<span style="text-align: justify">Por el momento no tenemos implementada la opción de crédito online y 
    solo financiamos en nuestros locales</span>
    <br/>
    <p><b>Requisitos de crédito</b></p>
    <span style="text-align: justify">La solicitud de nuestro crédito por primera vez será muy ágil, si traes lo siguiente:</span>
    <br/>
    <ol style="padding:0px 0px 0px 20px">
        <li>Comprobante de ocupación</li>
        <ul style="padding:0px 0px 0px 20px">
            <li>Si sos empleado podés presentar recibo de sueldo</li>
            <li>Si sos jubilado, recibo de jubilación</li>
            <li>Si sos profesional universitario, carné o justificativo de profesión</li>
            <li>Si sos unipersonal, recibo de pago de BPS o DGI (tu nombre deberá figurar en él)</li>
            <li>Si sos comerciante, planilla de trabajo (tu nombre deberá figurar en ella)</li>
        </ul>
        <li>Justificativo/s de sus referencias de crédito</li>
        <ul style="padding:0px 0px 0px 20px">
            <li>Estado de cuenta de una tarjeta de crédito (no Anda), idealmente acompañado por su recibo de pago</li>
            <li>Si no tenés tarjeta de crédito, podrás presentar los recibos de pagos consecutivos de un crédito en cuotas que hayas realizado por un monto similar al que solicitás con nosotros</li>
        </ul>
    </ol>
    <b>Notas</b>
    </br>
    <span style="text-align: justify">Aportar más datos, por ejemplo, recibo de sueldo de su cónyuge y recibo de pago de la tarjeta, facilitará el otorgamiento del crédito.</span>
    <ul style="padding:0px 0px 0px 20px">
        <li>Los datos deben actualizarse una vez al año</li>
        <li>La primera cuota se abona en el momento (excepto en los planes diferidos)</li>
    </ul>`;

    modalGlobal.showModal(
      '', message, true, null,
      null, false, null,
      'Cerrar', true, null,
    );
  }

  render() {
    const mobileVersion = ScreenStore.screenWidth <= constants.breakpoints.extraSmallMaxWidth;
    const summary = (
      <div className={styles.summarySection}>
        <Summary className={styles.summary} />
        <InfoModal
          id="compras-a-crédito"
          type="component"
          showConfirm={false}
          textCancel="Cerrar"
          showModal
        >
          <AlertZone
            title="COMPRAS A CRÉDITO"
            subtitle="Solo en nuestros locales"
          />
        </InfoModal>
      </div>
    );
    return (
      <div className={styles.container}>
        <SEO
          title="Carrito de Compras"
          description="Revisa los productos que has seleccionado en tu carrito de compras en Carlos Gutiérrez S.A. Aquí puedes ver detalles de tus artículos, cantidades y precios antes de proceder al pago. Modifica tu pedido fácilmente, agrega más productos o elimina los que ya no deseas. Disfruta de un proceso de compra seguro y conveniente con opciones de pago rápidas y diversas. ¡No esperes más! Finaliza tu compra y recibe tus productos directamente en la puerta de tu casa."
          type="website"
        />
        <HomeNavbar />
        <div className={styles.mainContent}>
          <div className={styles.cartData}>
            {
              !mobileVersion &&
              summary
            }
            <div className={styles.tableSection}>
              <h2 className={styles.title}>
                Carrito
              </h2>
              {
                mobileVersion &&
                summary
              }
              {
                !CartStore.isFetchingCart &&
                <ProductTable isCart />
              }
              {
                CartStore.isFetchingCart &&
                <Spinner className={styles.cartSpinner} />
              }
            </div>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
});

export { Cart };



// WEBPACK FOOTER //
// ./src/pages/cart/Cart.jsx